import classes from "./Separator.module.css";

const Separator = () => {
  return <div className={classes.separator} />;
};

export default Separator;
